<template>
    <proposal-form v-if="IsHydratedapp" :item="item" />
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import ProposalForm from './Form.vue';

    export default {
        components: {
            ProposalForm
        },

        data() {
            return {
                IsHydratedapp: true,
                item: {
                    company_id: null,
                    contact_id: null,
                    status: 26,
                    notable: false,
                    project_type: null,
                    borough: null,
                    block: null,
                    lot: null,
                    street: null,
                    building: null,
                    floor_number: null,
                    deposit_percent: null,
                    pay_in_full: false,
                    sales_id: null,
                    permit_type: null,
                    work_type_id: null,
                    terms_and_conditions: '',
                    project_name: '',
                    billed_to_company: null,
                    billed_to_contact: null,
                    created_by: null,
                    date_created: moment().format('YYYY-MM-DD'),
                    lead_source_id: null,
                    lead_contact_id: null
                }
            }
        },

        computed: {
            ...mapGetters(['defaultTermsAndConditions', 'appIsHydrated', 'currentUserId']),
        },

        created() {
          this.appIsHydrated = this.IsHydratedapp
            if (this.IsHydratedapp) {
                this.item.terms_and_conditions = this.defaultTermsAndConditions
                this.item.created_by = this.currentUserId
            }
            this.clearProjectServices()
        },

        watch: {
            'appIsHydrated'() {
                this.item.created_by = this.currentUserId
                this.item.terms_and_conditions = this.defaultTermsAndConditions
            }
        },

        methods: {
            ...mapActions(['clearProjectServices']),
        }
    }
</script>
